import { render } from "./DespachosView.vue?vue&type=template&id=44270a81&scoped=true"
import script from "./DespachosView.vue?vue&type=script&lang=js"
export * from "./DespachosView.vue?vue&type=script&lang=js"

import "./DespachosView.vue?vue&type=style&index=0&id=44270a81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44270a81"]])

export default __exports__